import { EntityCandidate } from "./models/EntityCandidate";
import { axiosInstance, sanitizeForLog, validateUuid } from "../utils";
import { IGetRowsParams } from "@ag-grid-community/core";

export async function getEntityCandidates(clientId: string, entityId: string | undefined, params: IGetRowsParams) {
    const axios = axiosInstance();

    try {
        const { qualifications, ...restFilterModel } = params.filterModel || {};
        const qualificationFilter = qualifications?.values?.join(",") || "";
        const cleanParams = { ...params, filterModel: restFilterModel };

        const response = await axios.get<{ rowsThisBlock: EntityCandidate[]; lastRow?: number }>(
            `api/Clients/${validateUuid(clientId)}/Entities/${validateUuid(entityId) ?? "all"}/candidates/grid`,
            {
                params: {
                    query: JSON.stringify(cleanParams),
                    qualificationFilter,
                },
            }
        );

        const rowsThisBlock = response.data.rowsThisBlock;

        return rowsThisBlock;
    } catch (error) {
        console.error("Error loading Entity Candidates data:", sanitizeForLog(error));
        return [];
    }
}

export async function getEntityCandidatesCount(clientId: string, entityId: string | undefined, params: IGetRowsParams) {
    const axios = axiosInstance();

    try {
        const { qualifications, ...restFilterModel } = params.filterModel || {};
        const qualificationFilter = qualifications?.values?.join(",") || "";
        const cleanParams = { ...params, filterModel: restFilterModel };

        const response = await axios.get<{ count: number }>(
            `api/Clients/${validateUuid(clientId)}/Entities/${validateUuid(entityId) ?? "all"}/candidates/count`,
            {
                params: {
                    query: JSON.stringify(cleanParams),
                    qualificationFilter,
                },
            }
        );

        const count = response.data.count;

        return count;
    } catch (error) {
        console.error("Error loading Entity Candidates Count data:", sanitizeForLog(error));
        return 0;
    }
}
